module.exports = __webpack_public_path__ + "static/media/1017700.9b32af93.png";